import { useState } from "react";
import { apiCall } from "../api";
import { SimplePage, inputClass, buttonClass } from "./SimplePage";

// Opened from the link in the password reset email (/restablecer?token=...)
const ResetPassword = () => {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const result = await apiCall('/auth/reset-password', 'POST', { token, password });
      setMessage(result.message);
    } catch (err) {
      setError(typeof err.detail === 'string' ? err.detail : 'La contraseña debe tener al menos 6 caracteres.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SimplePage title="Elige una contraseña nueva">
      {message ? (
        <div className="space-y-4">
          <p className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-3">{message}</p>
          <a href="/" className="block text-center bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 rounded-lg">Iniciar sesión</a>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} placeholder="Contraseña nueva (mínimo 6 caracteres)" />
          <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputClass} placeholder="Repite la contraseña" />
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <button type="submit" disabled={loading} className={buttonClass}>{loading ? 'Guardando...' : 'Guardar contraseña'}</button>
        </form>
      )}
    </SimplePage>
  );
};

export { ResetPassword };
